import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.reflect.construct";
import _classCallCheck from "/var/www/html/_limesurvey/assets/packages/questioneditor/node_modules/@babel/runtime-corejs2/helpers/esm/classCallCheck";
import _createClass from "/var/www/html/_limesurvey/assets/packages/questioneditor/node_modules/@babel/runtime-corejs2/helpers/esm/createClass";
import _inherits from "/var/www/html/_limesurvey/assets/packages/questioneditor/node_modules/@babel/runtime-corejs2/helpers/esm/inherits";
import _possibleConstructorReturn from "/var/www/html/_limesurvey/assets/packages/questioneditor/node_modules/@babel/runtime-corejs2/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/var/www/html/_limesurvey/assets/packages/questioneditor/node_modules/@babel/runtime-corejs2/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

/**
 * @license Copyright (c) 2003-2019, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/**
 * @module enter/shiftenter
 */
import ShiftEnterCommand from "./shiftentercommand";
import EnterObserver from "./enterobserver";
import Plugin from '@ckeditor/ckeditor5-core/src/plugin';
/**
 * This plugin handles the <kbd>Shift</kbd>+<kbd>Enter</kbd> keystroke (soft line break) in the editor.
 *
 * See also the {@link module:enter/enter~Enter} plugin.
 *
 * For more information about this feature see the {@glink api/enter package page}.
 *
 * @extends module:core/plugin~Plugin
 */

var ShiftEnter = /*#__PURE__*/function (_Plugin) {
  _inherits(ShiftEnter, _Plugin);

  var _super = _createSuper(ShiftEnter);

  function ShiftEnter() {
    _classCallCheck(this, ShiftEnter);

    return _super.apply(this, arguments);
  }

  _createClass(ShiftEnter, [{
    key: "init",
    value: function init() {
      var editor = this.editor;
      var schema = editor.model.schema;
      var conversion = editor.conversion;
      var view = editor.editing.view;
      var viewDocument = view.document; // Configure the schema.

      schema.register('softBreak', {
        allowWhere: '$text',
        isInline: true
      }); // Configure converters.

      conversion.for('upcast').elementToElement({
        model: 'softBreak',
        view: 'br'
      });
      conversion.for('downcast').elementToElement({
        model: 'softBreak',
        view: function view(modelElement, viewWriter) {
          return viewWriter.createEmptyElement('br');
        }
      });
      view.addObserver(EnterObserver);
      editor.commands.add('shiftEnter', new ShiftEnterCommand(editor));
      this.listenTo(viewDocument, 'enter', function (evt, data) {
        data.preventDefault(); // The hard enter key is handled by the Enter plugin.

        if (!data.isSoft) {
          return;
        }

        editor.execute('shiftEnter');
        view.scrollToTheSelection();
      }, {
        priority: 'low'
      });
    }
  }], [{
    key: "pluginName",

    /**
     * @inheritDoc
     */
    get: function get() {
      return 'ShiftEnter';
    }
  }]);

  return ShiftEnter;
}(Plugin);

export { ShiftEnter as default };